/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GeoBoundaryKind = {
    State: 'state',
    County: 'county',
    Town: 'town',
    Zip: 'zip',
} as const;
export type GeoBoundaryKind = typeof GeoBoundaryKind[keyof typeof GeoBoundaryKind];


export function instanceOfGeoBoundaryKind(value: any): boolean {
    for (const key in GeoBoundaryKind) {
        if (Object.prototype.hasOwnProperty.call(GeoBoundaryKind, key)) {
            if (GeoBoundaryKind[key as keyof typeof GeoBoundaryKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GeoBoundaryKindFromJSON(json: any): GeoBoundaryKind {
    return GeoBoundaryKindFromJSONTyped(json, false);
}

export function GeoBoundaryKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoBoundaryKind {
    return json as GeoBoundaryKind;
}

export function GeoBoundaryKindToJSON(value?: GeoBoundaryKind | null): any {
    return value as any;
}

export function GeoBoundaryKindToJSONTyped(value: any, ignoreDiscriminator: boolean): GeoBoundaryKind {
    return value as GeoBoundaryKind;
}

